const initSwiperSlider = (Swiper) => {
    new Swiper('#home-slider', {
        loop: true,
        speed: 1000,
        navigation: {
            nextEl: '.next-button',
            prevEl: '.prev-button',
        },
    });
}

export default initSwiperSlider;